import React, { Component } from "react";
import { matchPath } from "react-router";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as UsersActions } from "store/ducks/users";

import { Validate } from "common";
import { Page, Breadcrumbs } from "components";
import { Form } from "pages/Configs/Users/components";

class Edit extends Component {
  state = {
    data: {
      name: "",
      email: "",
      user_groups_attributes: [],
    },

    errors: {},

    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Configurações", to: "/configs" },
      { name: "Usuários", to: "/configs/users" },
      { name: "Detalhes", to: "" },
    ],
  };

  componentDidMount() {
    this.props.getUserRequest(this.handleGetId());
  }

  componentDidUpdate(oldProps) {
    const { user } = this.props;

    if (oldProps.user.loading && !user.loading) {
      this.setState({
        data: {
          user_id: user.data.attributes.access.auth_user_id,
          name: user.data.attributes.name,
          email: user.data.attributes.email,
          user_groups_attributes: user.data.attributes.access.groups.map(
            (group) => ({
              value: group.id,
              label: group.title,
            }),
          ),
        },
      });
    }
  }

  handleGetId = () => {
    const match = matchPath(this.props.location.pathname, {
      path: "/configs/users/:id/edit",
    });
    const { id } = match.params;

    return id;
  };

  handleValidate = () => {
    const { form } = this.state;

    const rules = {
      name: {
        required: true,
      },
    };

    const validate = Validate(form, rules);
    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  handleChange = (data) => {
    this.setState({ form: data });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (!this.handleValidate()) return;

    const { form } = this.state;

    const user = {
      user_groups_attributes: form.user_groups_attributes.map((group) => ({
        auth_group_id: group.value,
      })),
    };

    this.props.updateUserRequest(form.user_id, {
      ...user,
    });
  };

  render() {
    const { data, errors, breadcrumbs } = this.state;
    const { update } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form
          data={data}
          saving={update.loading}
          errors={errors}
          onChange={this.handleChange}
          onSubmit={this.handleSubmit}
        />
      </Page>
    );
  }
}

const mapState = (state) => ({
  user: state.users.detail,
  update: state.users.update,
});

const mapActions = (dispatch) => bindActionCreators(UsersActions, dispatch);

export default connect(mapState, mapActions)(Edit);
